export default ".headerLanguagelabel {\r\n    position: absolute;\r\n}";